<template>
    <div class="parking-pay-wrapper">
        <div class="parking-text">车位信息</div> 
        <div>
            <el-button v-if="care" @click="care=false" type="primary">切换为关怀模式</el-button>
            <el-button v-if="!care" @click="care=true" type="primary">切换为正常模式</el-button>
        </div>
        <!-- <article class="weui-article">
            <section>
                <div class="weui-cell weui-cell_active weui-cell_access  weui-cell_select-after weui-cell_plate">
                    <div  class="weui-cell__hd"><label class="weui-label">车牌号</label></div>
                    <div :class="{'weui-cell__bd_text': care == false, }" class="weui-cell__bd">{{ value || '无' }}</div>
                    <div class="car-box">
                        <span :class="`car-input ${chooseClass(index)}`" @click="handleCar(index)"
                            v-for="(item, index) in value" :key="index">{{ item }}</span>

                    </div>

                </div>
            </section>
        </article> -->




        <article class="weui-article">
            <section>
                <div class="weui-cell weui-cell_active weui-cell_access  weui-cell_select-after weui-cell_park">
                    <div class="weui-cell__hd"><label class="weui-label">车位编号</label></div>
                    <div :class="{'weui-cell__bd_text': care == false, }" class="weui-cell__bd">{{ parkInfo.parkingName || '无' }}</div>
                </div>
            </section>
        </article>
        <article class="weui-article">
			<section>
				<div class="weui-cell weui-cell_active weui-cell_access weui-cell_select weui-cell_select-after">
					<div  class="weui-cell__hd"><label class="weui-label">车牌类型</label></div>
					<div :class="{'weui-cell__bd_text': care == false, }" class="weui-cell__bd" @click="handleFeescaleOption">{{checkedFeescale || '无'}}</div>
				</div>
			</section>
		</article>



        <article class="weui-article">
            <section>
                <div class="weui-cell weui-cell_active weui-cell_access  weui-cell_select-after weui-cell_park">
                    <div  class="weui-cell__hd"><label class="weui-label">车位状态</label></div>
                    <div :class="{'weui-cell__bd_text': care == false, }" class="weui-cell__bd">{{ status }}</div>
                </div>
            </section>
        </article>
      



        <div class="weui-article">

            <div class="weui-cell  weui-cell_select-after weui-cell_park" v-if="statusType == 0">
                <div class="weui-cell__hd"><label class="weui-label">车位操作</label></div>
                <el-button  :class="{'weui-cell__bd_button': care == false, }" 
                        type="primary" @click="ApplyPark" v-if="statusType == 0">车辆进场</el-button>

          
            </div>
            <div class="weui-cell  weui-cell_select-after weui-cell_park" v-if="statusType != 0&&statusType!=4">
                <div class="weui-cell__hd"><label class="weui-label">车位操作</label></div>
                <el-button  :class="{'weui-cell__bd_button': care == false, }" 
                        type="primary" @click="ApplyPark" v-if="statusType == 0">车辆进场</el-button>

                <el-button  :class="{'weui-cell__bd_button': care == false, }" type="success" @click="OffPark" v-if="statusType != 0&&statusType!=4">车辆出场</el-button>
            </div>

        </div>
        <div class="weui-article" style="margin-top: 20px;" v-if=" statusType == 4">

            <div class="weui-cell  weui-cell_select-after weui-cell_park">
                <div class="weui-cell__hd"><label class="weui-label">确认操作</label></div>
                <!-- <el-button :class="{'weui-cell__bd_button': care == false, }" type="primary" @click="ManagerSubmit" v-if="statusType == 1">确认车辆进场</el-button> -->
                <!-- getManagerApplyPark -->
                <el-button :class="{'weui-cell__bd_button': care == false, }" type="success" @click="ManagerSubmitOff" v-if="statusType == 4">确认车辆出场</el-button>

            </div>

        </div>

        <!-- <article class="weui-article">
            <section>
                <div
                    class="weui-cell weui-cell_active weui-cell_access  weui-cell_select-after  weui-cell_select weui-cell_park">
                    <div class="weui-cell__hd"><label class="weui-label">改变状态</label></div>
                    <el-select v-model="value" placeholder="请选择">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </div>
            </section>
        </article> -->


        <el-drawer :visible.sync="show" direction="btt" :show-close="false" :withHeader="false">
            <div class="car-group">
                <div class="car-row" v-for="(item, index) in keys" :key="index">
                    <span @click="handleKey(item2)" class="car-cell" v-for="(item2, index2) in item" :key="index2">
                        {{ item2 }}
                    </span>
                    <span v-if="!isNewEnergy" @click="newEnergy" class="car-input car-new"></span>
                </div>
            </div>
        </el-drawer>




    </div>
</template>

<script>

import plateInput from '../../components/plateInput'
import { getRSparkInfo, getManagerApplyPark, getManagerOffPark, getManagerOffParkInfo, getManagerSubmit, getManagerSubmitOff } from "@/api/coupon/admin";

export default {
    name: "index",
    data() {
        return {
            care:true,
            feescalId:"",
            checkedFeescale:"",
            feescaleList:[
                {
                    label:"蓝牌车",
                    value:1

                },
                {
                    label:"黄牌车",
                    value:2
                },
            ],
            
            rsParkRecId: "",
            status: "",//车位状态
            parkInfo: [],
            value: ['', '', '', '', '', '', ''],  // 车牌值
            value2: '',
            show: false,
            // 各省的简称
            keyJC: [
                ['京', '粤', '津', '晋', '冀', '蒙', '辽', '吉', '黑', '渝'],
                ['苏', '浙', '皖', '闽', '赣', '鲁', '鄂', '沪', '宁'],
                ['桂', '琼', '川', '贵', '云', '藏', '陕', '新'],
                ['豫', '湘', '青', '甘']
            ],
            // 一般正常的键盘
            normalkey: [
                ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
                ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
                ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L',],
                ['Z', 'X', 'C', 'V', 'B', 'N', 'M',],
            ],
            // 油车最后一位键盘
            lastKey: [
                ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
                ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
                ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L', '警'],
                ['Z', 'X', 'C', 'V', 'B', 'N', 'M', '学',],
            ],
            index: 0, // 被选中的车牌位置
            isNewEnergy: false,
            id: "",
            statusType: "",

        }
    },
    components: {
        plateInput
    },
    computed: {
        chooseClass() {
            return function (index) {
                if (this.show) {
                    if (index == this.index) {
                        return 'choose-class'
                    }
                    else {
                        return ''
                    }
                } else {
                    return ''
                }

            }
        },
        keys() {
            let flag = this.index
            if (flag == 0) {
                return this.keyJC
            }
            else if (flag == 6) {
                return this.lastKey
            }
            else {
                return this.normalkey
            }
        }
    },
    model: {
        prop: 'value2',
        event: "change"
    },
    watch: {
        value() {
            let newStr = this.value.join()
            this.$emit('change', newStr)
        }
    },
    mounted() {
        // this.id = this.$route.query.id
        this.RSparkInfo()
    },
    methods: {
         /**点击收费规则选项*/
         handleFeescaleOption() {
                this.$weui.picker(this.feescaleList, {
                    onChange: result => {
                        this.feescalId = result[0].value;
                        this.checkedFeescale = result[0].label;
                        
                        
                        this.$forceUpdate()
                    },
                    onConfirm: result => {
                        this.feescalId = result[0].value;
                        this.checkedFeescale = result[0].label;
                      
                      
                        this.$forceUpdate()
                    },
					defaultValue: [parseInt(this.feescalId)],
                    title: '收费规则'
                });
			},
        //管理员确认车辆出厂
        ManagerSubmitOff() {
            
            let params = {
                id: this.rsParkRecId
            }
            getManagerSubmitOff(params).then(res => {

                if (res.code == 200) {
                    this.$weui.alert(res.msg)
                    // this.RSparkInfo()
                    this.$router.push({ name: "parkingLot", });
                    // this.$router.push({ name: 'options' })
                } else {
                    this.$weui.alert(res.msg)

                }

            })
        },
        //管理员确认车辆入场

        ManagerSubmit() {
            if (this.feescalId=="") {
                this.$weui.alert("请选择车牌类型")
                return
            }
            let params = {
                id:this.rsParkRecId,
                platetypeId:this.feescalId
            }
            getManagerSubmit(params).then(res => {
                console.log(res, 'res');
                if (res.code == 200) {
                    // this.RSparkInfo()

                    this.$weui.alert(res.msg)
                    this.$router.push({ name: "parkingLot", });
                    // this.$router.push({ name: 'options' })
                } else {
                    this.$weui.alert(res.msg)
                }

            })
        },
        //管理员车辆入场
        ApplyPark() {
            if (this.feescalId=="") {
                this.$weui.alert("请选择车牌类型")
                return
            }

            
            let params = {
                carNumber: this.value.join(''),
                // parkingName:this.parkInfo.parkingName,
                parkId: this.$route.query.parkId,
                platetypeId:this.feescalId
            }

            getManagerApplyPark(params).then(res => {
                console.log(res, '管理员车辆入场');
                if (res.code == 200) {
                    this.$weui.alert(res.msg)
                    // this.RSparkInfo()
                    this.$router.push({ name: "parkingLot", });

                } else {
                    this.$weui.alert(res.msg)

                }
            })
        },
        //管理员车辆出场
        OffPark() {
            console.log("111111111111111");
            let paramsId = {
                id: this.OffParkId
            }
            getManagerOffPark(paramsId).then(res => {
                console.log(res, 'res');
                if (res.code == 200) {
                    this.RSparkInfo()
                    // alert(res.msg);
                    this.$weui.alert(res.msg)



                    this.$router.push({ name: "parkingLot", });

                } else {
                    // alert(res.msg);

                    this.$weui.alert(res.msg)
                }
            })
        },
        // 点击车牌号码
        handleCar(index) {
            this.index = index
            this.show = true
        },
        // 点击键盘内容
        handleKey(key) {
            this.value[this.index] = key
            this.value = [...this.value]
            if (this.isNewEnergy) {
                if (this.index < 7) {
                    this.index++
                } else {
                    this.show = false
                }
            }
            else {
                if (this.index < 6) {
                    this.index++
                } else {
                    this.show = false
                }
            }
        },
        // 点击新能源
        newEnergy() {
            this.isNewEnergy = !this.isNewEnergy
            this.value[7] = ''
            this.index = 7
            this.show = true
        },

        RSparkInfo() {
            let params = {
                lotId: this.$route.query.lotId,
                parkingName: this.$route.query.parkingName
            }
            if (params.lotId == 10001) {
                params.lotId = params.lotId - 10000
            }
            getManagerOffParkInfo(params).then(res => {
                console.log(res, 'getRSparkInfo');
                this.parkInfo = res.data.parkingInfo
                this.statusType = res.data.parkingInfo.status
                if (res.data.rsParkRec) {
                    this.rsParkRecId = res.data.rsParkRec.id
                    this.feescalId = res.data.rsParkRec.platetypeId
                    if (this.feescalId==1) {
                            this.checkedFeescale = "蓝牌车"
                    }else{
                        this.checkedFeescale = "黄牌车"
                    }
                    this.OffParkId = res.data.rsParkRec.id
                    // this.value = res.data.rsParkRec.carNumber.split('')
                    this.value = res.data.rsParkRec.carNumber

                    this.parkInfo = res.data.parkingInfo
                    console.log(res.data.parkingInfo.status,'res.data.parkingInfo.status');

                    if (res.data.parkingInfo.status == 0) {
                        this.status = "空闲"
                    } else if (res.data.parkingInfo.status == 1) {
                        this.status = "已入场"
                    } else if (res.data.parkingInfo.status == 2) {
                        this.status = "已确认"
                    } else if (res.data.parkingInfo.status == 3) {
                        this.status = "异常"
                    } else if (res.data.parkingInfo.status == 4) {
                        this.status = "出场待确认"
                    } else {
                        this.status = "无"
                    }



                } else {
                    console.log(res.data.parkingInfo.status,'res.data.parkingInfo.status');
                    this.OffParkId = res.data.rsParkRec

                    this.parkInfo = res.data.parkingInfo

                    if (res.data.parkingInfo.status == 0) {

                        this.status = "空闲"
                    } else if (res.data.parkingInfo.status == 1) {
                        this.status = "入场待确认"
                    } else if (res.data.parkingInfo.status == 2) {
                        this.status = "已确认"
                    } else if (res.data.parkingInfo.status == 3) {
                        this.status = "异常"
                    } else if (res.data.parkingInfo.status == 4) {
                        this.status = "出场待确认"
                    } else {
                        this.status = "无"
                    }

                }


            })
        },
    }






}
</script>
<style  >
.car-box {
    display: flex;
}

.car-input {
    display: inline-block;
    position: relative;
    border: 1px solid #CCC;
    width: 25px;
    text-align: center;
    margin-right: 5px;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
}

.parking-text {
    font-size: 20px;
    font-weight: 600;
}

.car-input:nth-child(2):after {
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 100% + 20px;
    transform: translateY(-50%);
    height: 8px;
    width: 8px;
    border-radius: 4px;
    background-color: #00FF00;
    content: '',
}

.car-input:nth-child(2) {
    margin-right: 16px;
}

.choose-class {
    border: 2px solid #52cb9a !important;
}



.weui-cell__bd_text{
    font-size: 35px;
    font-weight: 600;

}
.weui-cell__bd_button{
    font-weight: 600;
    font-size: 35px !important;
    background-color: yellow !important;
    color: black !important;
    border: 1px solid yellow !important;
}



.car-group {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 100%;
    background-color: #e3e9ec;
}

.car-row {
    display: flex;
    justify-content: center;

}

.car-cell {
    margin: 0 3px;
    width: 33px;
    text-align: center;
    border-radius: 5px;
    border: 1px solid #CCC;
    font-size: 20px;
    background-color: #FFF;
}
</style>

<style scoped lang="stylus">
	@import '~common/stylus/variable'
	.parking-pay-wrapper{
		padding 20px 0
		.weui-article{
			padding-top 0
			padding-bottom 0
			section{
				margin-bottom 0
			}
			.weui-label{
				width 80px
			}
			.weui-cell__plate{
				flex unset
				width 35%
			}
			.weui-cell__plate:after{
				right 45%
			}
			.weui-cell_select-after{
				padding-left 0
			}
			.main-plate{
				font-size 14px
			}
			.weui-cell_select-after{
				display flex
				/*justify-content space-between*/
			}
			.weui-cell_park{
				.weui-cell__bd:after{
					width 0
					height: 0;
				}
			}
		}
		.user-info{
			font-size 16px
			color #6d6d6d
			padding 10px 15px
			display flex
			/*justify-content space-around*/
		}
		.weui-btn-area{
			margin-top 50px
			.weui-btn_primary, .weui-btn_disabled{
				width 100%
			}
		}
	}
.weui-form-preview__item{
    display: flex;
    margin-top:20px
}
.color{
    color: #8b8080;
}
.weui-cell{
    padding:0;
}
</style>
